document.addEventListener("DOMContentLoaded", function() {

    if(typeof (lightGallery) === 'undefined')
        return;

    (function () {
        let galleryEl = document.querySelector('.JS-lightgallery-detail');
        if(typeof(galleryEl) === 'undefined' || galleryEl === null)
            return;

        const gallery = lightGallery(galleryEl, {
            selector: '.JS-lightgallery-item',
            thumbnail: true,
            animateThumb: true,
            showThumbByDefault: true,
            zoom: true,
            exThumbImage: 'data-exthumbimage'
        });

        const openPhoto = document.querySelector('.js-photo');
        if (!openPhoto)
            return;

        const position = getComputedStyle(openPhoto).getPropertyValue('--countOfPhotos');

        openPhoto.addEventListener('click', () => {
            gallery.openGallery(Number(position));
        })
    }());
});